import * as React from 'react';

import type { SupplierMeClient } from '@/api/supplier-me-client';
import { HttpSupplierMeClient } from '@/api/supplier-me-client.http';

// =============================================================================
// supplier-me-client-context.tsx — Injection du SupplierMeClient (DI seam, S0-ROLE, Option B).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut : l'adaptateur HTTP RÉEL
// (HttpSupplierMeClient) — le BACK (whoami + contacts/me) est livré. Câblé HTTP DÈS LE DÉPART
// (garde 09_stub_in_prod_guard : aucun défaut stub-en-prod). Les tests du bootstrap auth injectent un
// StubSupplierMeClient (session présente / absente) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session fournisseur). */
const defaultSupplierMeClient: SupplierMeClient = new HttpSupplierMeClient();

const SupplierMeClientContext =
  React.createContext<SupplierMeClient>(defaultSupplierMeClient);

export interface SupplierMeClientProviderProps {
  client?: SupplierMeClient | undefined;
  children: React.ReactNode;
}

export function SupplierMeClientProvider({
  client = defaultSupplierMeClient,
  children,
}: SupplierMeClientProviderProps): React.JSX.Element {
  return (
    <SupplierMeClientContext.Provider value={client}>
      {children}
    </SupplierMeClientContext.Provider>
  );
}

export function useSupplierMeClient(): SupplierMeClient {
  return React.useContext(SupplierMeClientContext);
}
